export enum ShowOnlyValues {
  PrintContent = 'Print Content',
  HasTopic = 'Has Topic',
  OnTicker = 'On Ticker',
  Published = 'Published',
  PendingTranscript = 'Pending Transcript',
  FeaturedStory = 'Featured Story',
  Commentary = 'Commentary',
  TopStory = 'Top Story',
}
